import { FilterTag } from 'components/filtertags'
import { useMemoWithDeepCompare } from 'hooks/useMemoWithDeepCompare'
import { useLocalStorageState } from 'hooks/useStorage'

import { useAcessoLotacaoOrEstagio } from '../../../../components/auth/useAcessoLotacao'
import {
  convertAtividadeColetivaGruposFilterFormModelToInputModel,
  getTipoGrupoEnumDescription,
} from '../converter-atividadeColetivaGrupos'
import { AtividadeColetivaGruposFilterFormModel } from '../model-atividadeColetivaGrupos'

export const useAtividadeColetivaGruposFilter = () => {
  const {
    acesso,
    acesso: { unidadeSaude },
  } = useAcessoLotacaoOrEstagio()

  const filterStorageKey = `${acesso.id}/atividade-coletiva-grupos-filter`
  const [filter, setFilter] = useLocalStorageState<AtividadeColetivaGruposFilterFormModel>(filterStorageKey, {
    defaultValue: {
      showOnlyInativos: false,
      isSomenteRegistrosProprios: false,
      unidadesSaude: [unidadeSaude],
      pageParams: {
        page: 0,
        size: 10,
        sort: ['-dataUltimaAtualizacao'],
      },
    },
  })

  const convertedFilter = useMemoWithDeepCompare(
    () => convertAtividadeColetivaGruposFilterFormModelToInputModel(filter),
    [filter]
  )

  const unidadeSaudeFilterTag = filter.unidadesSaude?.map((unidade) => unidade.nome).join(', ')
  const equipeFilterTag = filter.equipes
    ? [...new Set(filter.equipes.map((equipe) => equipe.nome))].join(', ')
    : undefined
  const tipoGrupoFilterTag = getTipoGrupoEnumDescription(filter.tipoGrupo)
  const statusGrupoAtivoFilterTag = filter.showOnlyInativos && 'Somente inativos'

  const filterTags: FilterTag[] = [
    ['Unidade de saúde', unidadeSaudeFilterTag],
    ['Equipe', equipeFilterTag],
    ['Tipo de grupo', tipoGrupoFilterTag],
    ['Status do grupo', statusGrupoAtivoFilterTag],
  ]

  return { filter, setFilter, convertedFilter, filterTags }
}
